import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mat-icon-bkg',
  templateUrl: './mat-icon-bkg.component.html',
  styleUrls: ['./mat-icon-bkg.component.scss']
})
export class MatIconBkgComponent implements OnInit {
@Input() iconName : string;
@Input() colorScheme : string;

  constructor() {
    
   }

  ngOnInit(): void {
    // console.log (`in MatIconBKG color scheme is ${this.colorScheme} icon Name is ${this.iconName}`);
  }
}
